// 到着予定日の日付を取得する関数
(function getArrivalDay() {
  // 営業日をカウントするカウンター
  let businessDaysCount = 0;

  // 到着予定営業日数：2日後
  const estimatedArrivalBusinessDays = 2;

  // 到着予定日：購入日
  let estimatedArrivalDate = new Date(
    new Date().toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" }),
  );

  // 営業日を数える
  while (businessDaysCount < estimatedArrivalBusinessDays) {
    estimatedArrivalDate.setDate(estimatedArrivalDate.getDate() + 1);

    // 休日、土曜日、または日曜日の場合、カウントしない
    if (
      !holidays.includes(formatDate(estimatedArrivalDate)) &&
      estimatedArrivalDate.getDay() !== 0 &&
      estimatedArrivalDate.getDay() !== 6
    ) {
      businessDaysCount++;
    }
  }

  // カートの note に値を入力
  // 到着予定日は毎回更新
  const cartAttributesDom = document.getElementById("cartAttributes");
  const cartRemarksDom = document.getElementById("remarks");
  const orderNumberDom = document.getElementById("orderNumber");
  const subjectDom = document.getElementById("subject");
  const deliveryNoticeNotRequiredDom = document.getElementById(
    "delivery_notice_not_required_text",
  );

  const cartAttributesObj = JSON.parse(cartAttributesDom?.value || "{}");
  cartAttributesObj["desired_delivery_date"] = `${formatDate(
    estimatedArrivalDate,
  )}`;
  cartAttributesObj["remarks"] = cartAttributesObj["remarks"] || "";
  cartAttributesObj["order_number"] = cartAttributesObj["order_number"] || "";
  cartAttributesObj["subject"] = cartAttributesObj["subject"] || "";
  cartAttributesObj["delivery_notice_not_required_text"] =
    cartAttributesObj["delivery_notice_not_required_text"] || "";

  cartAttributesDom.value = JSON.stringify(cartAttributesObj);
  cartRemarksDom.value = cartAttributesObj["remarks"] || "";
  orderNumberDom.value = cartAttributesObj["order_number"] || "";
  subjectDom.value = cartAttributesObj["subject"] || "";
  deliveryNoticeNotRequiredDom.checked =
    cartAttributesObj["delivery_notice_not_required_text"] !== "";

  fetch("/cart/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      attributes: { "cart note": JSON.stringify(cartAttributesObj) },
    }),
  })
    .then(() => {
      window.cartNoteReady = true;
      if (window._cartNoteObserver) {
        window._cartNoteObserver.disconnect();
        window._cartNoteObserver = null;
      }
      var checkoutButtons = document.querySelectorAll('button[name="checkout"]');
      var caution1 = document.getElementById('caution_1');
      var caution2 = document.getElementById('caution_2');
      var cautionOk = (!caution1 || caution1.checked) && (!caution2 || caution2.checked);
      if (cautionOk) {
        checkoutButtons.forEach(function(button) {
          button.disabled = false;
          button.style.opacity = '1';
          button.style.cursor = 'pointer';
          button.style.pointerEvents = 'auto';
          button.style.backgroundColor = '#6464e6';
        });
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
})();

// cart note がセットされるまでチェックアウトボタンを無効化し続ける
// BSS B2B が style 属性を上書きしても再度無効化する
(function() {
  function disableCheckoutButtons() {
    var buttons = document.querySelectorAll('button[name="checkout"]');
    buttons.forEach(function(button) {
      button.disabled = true;
      button.style.pointerEvents = 'none';
      button.style.opacity = '0.7';
      button.style.cursor = 'not-allowed';
    });
  }

  // 初回適用
  disableCheckoutButtons();

  // BSS B2B による style 上書きを監視して再度無効化
  var observer = new MutationObserver(function() {
    if (!window.cartNoteReady) {
      disableCheckoutButtons();
    }
  });

  var buttons = document.querySelectorAll('button[name="checkout"]');
  buttons.forEach(function(button) {
    observer.observe(button, { attributes: true, attributeFilter: ['style'] });
  });

  window._cartNoteObserver = observer;
})();

// cart note を再作成する関数（チェックアウト時のバリデーションで使用）
function rebuildCartNote() {
  var businessDaysCount = 0;
  var estimatedArrivalBusinessDays = 2;
  var estimatedArrivalDate = new Date(
    new Date().toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" }),
  );

  while (businessDaysCount < estimatedArrivalBusinessDays) {
    estimatedArrivalDate.setDate(estimatedArrivalDate.getDate() + 1);
    if (
      !holidays.includes(formatDate(estimatedArrivalDate)) &&
      estimatedArrivalDate.getDay() !== 0 &&
      estimatedArrivalDate.getDay() !== 6
    ) {
      businessDaysCount++;
    }
  }

  var cartAttributesDom = document.getElementById("cartAttributes");
  var cartRemarksDom = document.getElementById("remarks");
  var orderNumberDom = document.getElementById("orderNumber");
  var subjectDom = document.getElementById("subject");
  var deliveryNoticeNotRequiredDom = document.getElementById(
    "delivery_notice_not_required_text",
  );

  var cartAttributesObj = {};
  try {
    cartAttributesObj = JSON.parse(cartAttributesDom?.value || "{}");
  } catch (ex) {}

  cartAttributesObj["desired_delivery_date"] = formatDate(estimatedArrivalDate);
  cartAttributesObj["remarks"] =
    (cartRemarksDom && cartRemarksDom.value) ||
    cartAttributesObj["remarks"] ||
    "";
  cartAttributesObj["order_number"] =
    (orderNumberDom && orderNumberDom.value) ||
    cartAttributesObj["order_number"] ||
    "";
  cartAttributesObj["subject"] =
    (subjectDom && subjectDom.value) || cartAttributesObj["subject"] || "";
  cartAttributesObj["delivery_notice_not_required_text"] =
    deliveryNoticeNotRequiredDom && deliveryNoticeNotRequiredDom.checked
      ? "納品通知票・物品受領証添付不要"
      : "";

  cartAttributesDom.value = JSON.stringify(cartAttributesObj);

  return fetch("/cart/update", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      attributes: { "cart note": JSON.stringify(cartAttributesObj) },
    }),
  });
}

// 与えられた日付を yyyy-mm-dd 形式の文字列にフォーマットするユーティリティ関数
function formatDate(date) {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
}

// カートの情報を cart note に JSON で保存する関数
function saveCartNote() {
  // カートの note に値を入力
  const cartRemarksDom = document.getElementById("remarks");

  // カートの note に値を入力
  const cartAttributesDom = document.getElementById("cartAttributes");
  const cartAttributesObj = JSON.parse(cartAttributesDom.value);
  cartAttributesObj["remarks"] = cartRemarksDom.value;
  cartAttributesDom.value = JSON.stringify(cartAttributesObj);

  fetch("/cart/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      attributes: { "cart note": JSON.stringify(cartAttributesObj) },
    }),
  })
    .then(() => {})
    .catch((error) => {
      console.error("Error:", error);
    });
}

function saveOrderNumber() {
  // カートの note に値を入力
  const orderNumberDom = document.getElementById("orderNumber");

  // カートの note に値を入力
  const cartAttributesDom = document.getElementById("cartAttributes");
  const cartAttributesObj = JSON.parse(cartAttributesDom.value);
  cartAttributesObj["order_number"] = orderNumberDom.value;
  cartAttributesDom.value = JSON.stringify(cartAttributesObj);

  fetch("/cart/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      attributes: { "cart note": JSON.stringify(cartAttributesObj) },
    }),
  })
    .then(() => {})
    .catch((error) => {
      console.error("Error:", error);
    });
}

function saveSubject() {
  // カートの note に値を入力
  const subjectDom = document.getElementById("subject");

  // カートの note に値を入力
  const cartAttributesDom = document.getElementById("cartAttributes");
  const cartAttributesObj = JSON.parse(cartAttributesDom.value);
  cartAttributesObj["subject"] = subjectDom.value;
  cartAttributesDom.value = JSON.stringify(cartAttributesObj);

  fetch("/cart/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      attributes: { "cart note": JSON.stringify(cartAttributesObj) },
    }),
  })
    .then(() => {})
    .catch((error) => {
      console.error("Error:", error);
    });
}

// 納品通知票不要テキストを保存する関数
function saveDeliveryNoticeNotRequired(isChecked) {
  const cartAttributesDom = document.getElementById("cartAttributes");
  const cartAttributesObj = JSON.parse(cartAttributesDom.value || "{}");

  // チェックボックスの状態に応じて値を設定
  const deliveryNoteText = "納品通知票・物品受領証添付不要";
  cartAttributesObj["delivery_notice_not_required_text"] = isChecked
    ? deliveryNoteText
    : "";
  cartAttributesDom.value = JSON.stringify(cartAttributesObj);

  // カートのアトリビュートを更新
  fetch("/cart/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      attributes: { "cart note": JSON.stringify(cartAttributesObj) },
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Delivery notice preference updated:", data.attributes);
    })
    .catch((error) => {
      console.error("Error updating delivery notice preference:", error);
    });
}
